var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"langSwitch"},[_c('i'),_c('p',{on:{"click":function($event){_vm.changeLang(_vm.$Storage.get('locale') === 'E' ? 'C' : 'E')}}},[_vm._v(_vm._s(_vm.langText))])])}
var staticRenderFns = []

export { render, staticRenderFns }